// A drop zone or a colour swatch is a label around a hidden file or colour input; its whole area must open it.
const KEEPS_LABEL_CLICK = new Set(['checkbox', 'radio', 'file', 'color']);
const INTERACTIVE = 'input, select, textarea, button, a[href], [role="button"], [contenteditable="true"], summary';

/**
 * A <label> forwards any click inside it to its field. Around a date or a select that means a tap
 * on empty space opens a picker on a phone. A checkbox or a radio keeps that behaviour,
 * so its caption still toggles it.
 */
export function installLabelFocusGuard() {
  window.addEventListener(
    'click',
    (event) => {
      const target = event.target as Element | null;
      if (!target || !(target instanceof Element)) return;
      const label = target.closest('label');
      if (!label) return;
      if (target.closest(INTERACTIVE)) return;
      const control = label.control;
      if (!control) return;
      if (control instanceof HTMLInputElement && KEEPS_LABEL_CLICK.has(control.type)) return;
      event.preventDefault();
    },
    true,
  );
}
